export class RegisterEntryForms {
  public static get LOGIN(): string {
    return 'login';
  }

  public static get NEW_COMPANY(): string {
    return 'new-company';
  }
}
